import { CaseLevel2Code, CaseLevel3Code } from 'shared/constants/common-cases';
import type { CaseLevel3Option } from 'shared/models/common-cases';

export default function getCaseLevels3BasedOnCaseLevel2(
  caseLevel2: CaseLevel2Code | null,
  caseLevels3: CaseLevel3Option[]
) {
  if (!caseLevel2) return [];

  switch (caseLevel2) {
    case CaseLevel2Code.Reclamation:
      return caseLevels3.filter(({ Value }) => {
        return [
          CaseLevel3Code.PM,
          CaseLevel3Code.Maintenance,
          CaseLevel3Code.Cleaning,
          CaseLevel3Code.Disposal,
        ].includes(Value);
      });
    case CaseLevel2Code.Idea:
      return caseLevels3.filter(({ Value }) => {
        return [
          CaseLevel3Code.GeneralMeeting,
          CaseLevel3Code.DevelopmentIdea,
        ].includes(Value);
      });
    case CaseLevel2Code.ResidentChanges:
      return caseLevels3.filter(({ Value }) => {
        return [
          CaseLevel3Code.NameTagChange,
          CaseLevel3Code.NameChange,
          CaseLevel3Code.NumberOfResidents,
        ].includes(Value);
      });
    case CaseLevel2Code.Balance:
      return caseLevels3.filter(({ Value }) => {
        return [
          CaseLevel3Code.Receivables,
          CaseLevel3Code.Prepayments,
        ].includes(Value);
      });
    case CaseLevel2Code.Loans:
      return caseLevels3.filter(({ Value }) => {
        return [CaseLevel3Code.PayingLoan, CaseLevel3Code.LoanReport].includes(
          Value
        );
      });
    case CaseLevel2Code.ParkingLot:
    case CaseLevel2Code.Garage:
    case CaseLevel2Code.Sauna:
    case CaseLevel2Code.OtherSpace:
      return caseLevels3.filter(({ Value }) => {
        return [
          CaseLevel3Code.Reservation,
          CaseLevel3Code.EndingContract,
          CaseLevel3Code.Inquiry,
        ].includes(Value);
      });
    case CaseLevel2Code.Outdoors:
      return caseLevels3.filter(({ Value }) =>
        [
          CaseLevel3Code.WinterMaintenance,
          CaseLevel3Code.GreenAreas,
          CaseLevel3Code.Other,
        ].includes(Value)
      );
    default:
      return [];
  }
}
